// Generator-discovered file route for the conversational intake. Component
// lives in `src/ad/routes/intake.tsx` (CI-11/CI-12 — the default New Brief).
import { createFileRoute } from '@tanstack/react-router';
import { IntakeRouteComponent } from '@/ad/routes/intake';

export const Route = createFileRoute('/_authenticated/ad/intake')({
  component: IntakeRouteComponent,
});
